import React from 'react';
import { useSelector } from 'react-redux';

import { selectAlertModalComponent, selectAlertModalProps } from '../../redux/modules/alertModal';

import AlertContainer from './AlertContainer';

function AlertModal() {
  const Component = useSelector(selectAlertModalComponent);
  const alertProps = useSelector(selectAlertModalProps);

  if (!Component) return null;

  return (
    <AlertContainer>
      <Component {...alertProps} />
    </AlertContainer>
  );
}

export default AlertModal;
